// Tải file lên Cloudinary từ trình duyệt (unsigned upload preset).
// Không dùng API secret — dự án không có backend/Cloud Functions để ký upload.
// Cloud name + upload preset nằm trong bundle nên preset unsigned PHẢI giới hạn
// (folder, dung lượng, định dạng) trên dashboard Cloudinary.

const DUNG_LUONG_TOI_DA = 10 * 1024 * 1024; // 10MB — khớp giới hạn cũ của Firebase Storage

export async function taiLenCloudinary(file, { thuMuc } = {}) {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) {
    throw new Error(
      "Chưa cấu hình Cloudinary. Thêm REACT_APP_CLOUDINARY_CLOUD_NAME và REACT_APP_CLOUDINARY_UPLOAD_PRESET vào frontend/.env rồi chạy lại npm start."
    );
  }

  if (!file) throw new Error("Chưa chọn file.");
  if (file.size > DUNG_LUONG_TOI_DA) {
    throw new Error("File vượt quá 10MB.");
  }

  const form = new FormData();
  form.append("file", file);
  form.append("upload_preset", uploadPreset);
  if (thuMuc) form.append("folder", thuMuc);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
    method: "POST",
    body: form,
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok || data.error) {
    throw new Error(data.error?.message || "Tải lên Cloudinary thất bại.");
  }
  if (!data.secure_url) {
    throw new Error("Cloudinary không trả về URL file.");
  }

  return data.secure_url;
}

export { DUNG_LUONG_TOI_DA };
